/** 单轮产物协议，与桌面端/App 的 metadata.resultManifest 保持兼容。 */
export interface CoworkResultManifest {
  version: 1;
  artifacts: Array<{ path: string; name: string; kind: 'file'; size?: number; exists?: boolean }>;
  sources: Array<{ url: string }>;
  validations: Array<{ name: string; status: string; detail?: string }>;
  warnings: string[];
  issues: Array<{ code: string; message: string; userVisible: boolean; recoverable: boolean }>;
}

/** 从未知消息元数据读取清单；只接受能由会话文件接口处理的文件记录。 */
export function readResultManifest(value: unknown): CoworkResultManifest | undefined {
  if (!value || typeof value !== 'object') return undefined;
  const record = value as CoworkResultManifest;
  if (!Array.isArray(record.artifacts)) return undefined;
  return { ...record, artifacts: record.artifacts.filter(a => a && typeof a.path === 'string' && typeof a.name === 'string') };
}
